import {
    MANAGEMENT_COMMON_DAYS,
    MANAGEMENT_COMMON_HOURS,
    MANAGEMENT_COMMON_MINUTES,
    MANAGEMENT_LAST_SYNCED_TEXT,
} from "app/pages/sales-intelligence/pages/management/translations/managementKeys";

import { salesforceFormatDate } from "./salesforceFormatDate";

export const formatLastSyncedLine = (
    lastSynced: string | undefined,
    translate: (key: string) => string,
): string | undefined => {
    if (!lastSynced) {
        return undefined;
    }
    const relative = salesforceFormatDate(
        `${lastSynced}Z`,
        translate(MANAGEMENT_COMMON_MINUTES),
        translate(MANAGEMENT_COMMON_HOURS),
        translate(MANAGEMENT_COMMON_DAYS),
    );
    return `${translate(MANAGEMENT_LAST_SYNCED_TEXT)}: ${relative}`;
};
